import React, {useMemo} from "react";
import {ConfigProvider, Tabs} from "antd";
import {useLocation} from "react-router-dom";
import {Redirect, Route, Switch} from "react-router";
import {ResponsiveView} from "../../components/index.jsx";
import {Devices} from "../../components/ResponsiveView/consts.js";
import {extractTabFromUrl} from "../DefaultAppDashboard.jsx";
import {DeliveryProviderDeliveriesWrapper} from "./DeliveryProviderDeliveries/DeliveryProviderDeliveriesWrapper.jsx";
import {DriverDeliveriesWrapper} from "../../delivery/driverDeliveries/DriverDeliveriesWrapper.jsx";
import DeliveryProviderManageInvoices from "./DeliveryProviderManageInvoices/DeliveryProviderManageInvoices";

const {TabPane} = Tabs;

export const DeliveryProviderDashboard = ({history}) => {
    const location = useLocation();

    const activeKey = useMemo(() => {
        const routes = ["deliveries", "reports", "mydeliveries", "invoices"];

        return extractTabFromUrl(RegExp(`^\/dashboard\/(${routes.join("|")})(.*)$`));
    }, [location.pathname]);

    return !activeKey ? (
        <Redirect to="/dashboard/deliveries" />
    ) : (
        <ConfigProvider direction="rtl">
            <Switch>
                <Route exact={true} path="/dashboard/deliveries" component={DeliveryProviderDeliveriesWrapper} />
                <Route exact={true} path="/dashboard/mydeliveries" component={DriverDeliveriesWrapper} />
                <Route exact={true} path="/dashboard/invoices" component={DeliveryProviderManageInvoices} />
            </Switch>

            <ResponsiveView devices={[Devices.desktop]}>
                <Tabs
                    activeKey={activeKey}
                    onTabClick={key => history.push(`/dashboard/${key}`)}
                    centered={true}
                    className="provider-dashboard-tabs">
                    <TabPane tab="ניהול משלוחים" key="deliveries" />
                    <TabPane tab="המשלוחים שלי" key="mydeliveries" />
                    <TabPane tab="העלאת חשבוניות" key="invoices" />
                </Tabs>
            </ResponsiveView>
        </ConfigProvider>
    );
};
